import { render, staticRenderFns } from "./PremiumPlanAccountSelectPage.vue?vue&type=template&id=5b2c71f6&scoped=true&"
import script from "./PremiumPlanAccountSelectPage.vue?vue&type=script&lang=ts&"
export * from "./PremiumPlanAccountSelectPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c71f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardSubtitle,VContainer,VDivider})
